"use strict";

var _slicedToArray = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

function useViewportHeight() {
  var _react_1$useState = react_1.useState(function () {
    var _a;

    return ((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.height) || window.innerHeight;
  }),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      height = _react_1$useState2[0],
      setHeight = _react_1$useState2[1];

  react_1.useLayoutEffect(function () {
    var _a;

    var handleResize = function handleResize() {
      setHeight(function () {
        var _a;

        return ((_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.height) || window.innerHeight;
      });
    };

    (_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.addEventListener("resize", handleResize);
    return function () {
      var _a;

      (_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.removeEventListener("resize", handleResize);
    };
  }, []);
  return height;
}

exports.default = useViewportHeight;